// AUTOGENERATED
import * as $runtime from "../runtime.js";
import * as Data$dDateTime from "../Data.DateTime/index.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMoney$dRounded from "../Data.Money.Rounded/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Data$dTime$dLocal from "../Data.Time.Local/index.js";
import * as Data$dUTCTime from "../Data.UTCTime/index.js";
import * as Data$dUUID from "../Data.UUID/index.js";
import * as DateUtils from "../DateUtils/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dNullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Restaumatic$dAnalytics$dTypes$dItemList from "../Restaumatic.Analytics.Types.ItemList/index.js";
import * as Restaumatic$dCurrencies from "../Restaumatic.Currencies/index.js";
import * as Restaumatic$dGeocoding$dTypes$dDeliveryAddress from "../Restaumatic.Geocoding.Types.DeliveryAddress/index.js";
import * as Restaumatic$dOrders$dTypes$dCoupon from "../Restaumatic.Orders.Types.Coupon/index.js";
import * as Restaumatic$dOrders$dTypes$dFulfillmentMethodType from "../Restaumatic.Orders.Types.FulfillmentMethodType/index.js";
import * as Restaumatic$dOrders$dTypes$dOrderOrigin from "../Restaumatic.Orders.Types.OrderOrigin/index.js";
import * as Restaumatic$dOrders$dTypes$dOrderUUID from "../Restaumatic.Orders.Types.OrderUUID/index.js";
import * as Restaumatic$dOrders$dTypes$dTip from "../Restaumatic.Orders.Types.Tip/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unscramble from "../Unscramble/index.js";
const eq1 = x => y => {
  if (x.tag === "Nothing") { return y.tag === "Nothing"; }
  if (x.tag === "Just") {
    if (y.tag === "Just") { return Restaumatic$dAnalytics$dTypes$dItemList.eqItemList.eq(x._1)(y._1); }
    return false;
  }
  return false;
};
const eq8 = /* #__PURE__ */ (() => Data$dEq.eqArrayImpl(Restaumatic$dOrders$dTypes$dCoupon.eqCoupon.eq))();
const eq11 = x => y => {
  if (x.tag === "Nothing") { return y.tag === "Nothing"; }
  if (x.tag === "Just") {
    if (y.tag === "Just") { return Restaumatic$dGeocoding$dTypes$dDeliveryAddress.eqDeliveryAddress.eq(x._1)(y._1); }
    return false;
  }
  return false;
};
const eq14 = x => y => {
  if (x.tag === "Nothing") { return y.tag === "Nothing"; }
  if (x.tag === "Just") {
    if (y.tag === "Just") { return Restaumatic$dOrders$dTypes$dOrderOrigin.eqOrderOrigin.eq(x._1)(y._1); }
    return false;
  }
  return false;
};
const eq15 = x => y => {
  if (x.tag === "Nothing") { return y.tag === "Nothing"; }
  if (x.tag === "Just") {
    if (y.tag === "Just") { return Data$dDateTime.eqDateTime.eq(x._1)(y._1); }
    return false;
  }
  return false;
};
const categoryIsSymbol = {reflectSymbol: () => "category"};
const listIsSymbol = {reflectSymbol: () => "list"};
const nameIsSymbol = {reflectSymbol: () => "name"};
const productIdIsSymbol = {reflectSymbol: () => "productId"};
const promotionIsSymbol = {reflectSymbol: () => "promotion"};
const quantityIsSymbol = {reflectSymbol: () => "quantity"};
const ratingIsSymbol = {reflectSymbol: () => "rating"};
const totalIsSymbol = {reflectSymbol: () => "total"};
const unitPriceIsSymbol = {reflectSymbol: () => "unitPrice"};
const showMaybe = {
  show: v => {
    if (v.tag === "Just") { return "(Just " + Data$dShow.showIntImpl(v._1) + ")"; }
    if (v.tag === "Nothing") { return "Nothing"; }
    $runtime.fail();
  }
};
const ItemInfoIsSymbol = {reflectSymbol: () => "ItemInfo"};
const decodeRecordCons = /* #__PURE__ */ Unscramble.decodeRecordCons(nameIsSymbol)(Unscramble.decodeString1);
const decodeMaybe = /* #__PURE__ */ Unscramble.decodeMaybe(Unscramble.decodeInt1);
const decodeRecordCons1 = /* #__PURE__ */ Unscramble.decodeRecordCons(totalIsSymbol)(Data$dMoney$dRounded.udecodeMoney);
const valueIsSymbol = {reflectSymbol: () => "value"};
const DiscountInfoIsSymbol = {reflectSymbol: () => "DiscountInfo"};
const couponsIsSymbol = {reflectSymbol: () => "coupons"};
const createdAtIsSymbol = {reflectSymbol: () => "createdAt"};
const currencyIsSymbol = {reflectSymbol: () => "currency"};
const customerTotalIsSymbol = {reflectSymbol: () => "customerTotal"};
const deliveryAddressIsSymbol = {reflectSymbol: () => "deliveryAddress"};
const deliveryCostIsSymbol = {reflectSymbol: () => "deliveryCost"};
const deliveryRatingIsSymbol = {reflectSymbol: () => "deliveryRating"};
const discountsIsSymbol = {reflectSymbol: () => "discounts"};
const fulfillmentMethodTypeIsSymbol = {reflectSymbol: () => "fulfillmentMethodType"};
const idIsSymbol = {reflectSymbol: () => "id"};
const itemsIsSymbol = {reflectSymbol: () => "items"};
const onlinePaymentIsSymbol = {reflectSymbol: () => "onlinePayment"};
const originIsSymbol = {reflectSymbol: () => "origin"};
const requestedFulfillmentTimeIsSymbol = {reflectSymbol: () => "requestedFulfillmentTime"};
const restaurantRatingIsSymbol = {reflectSymbol: () => "restaurantRating"};
const restaurantTotalIsSymbol = {reflectSymbol: () => "restaurantTotal"};
const timezoneIsSymbol = {reflectSymbol: () => "timezone"};
const tipIsSymbol = {reflectSymbol: () => "tip"};
const uuidIsSymbol = {reflectSymbol: () => "uuid"};
const OrderInfoIsSymbol = {reflectSymbol: () => "OrderInfo"};
const encodeWithOptionsOther = {encodeWithOptions: v => Data$dMoney$dRounded.encodeMoney.encode};
const encodeWithOptionsOther1 = {
  encodeWithOptions: v => v2 => {
    if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
    if (v2.tag === "Just") { return v2._1; }
    $runtime.fail();
  }
};
const encodeWithOptionsOther2 = {encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce};
const encodeWithOptionsOther3 = {encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce};
const decodeWithOptionsOther = {decodeWithOptions: v => Data$dMoney$dRounded.decodeMoney.decode};
const decodeWithOptionsOther1 = {decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign$dGeneric$dClass.intDecode.decode)};
const decodeWithOptionsOther2 = {decodeWithOptions: v => Foreign$dGeneric$dClass.booleanDecode.decode};
const decodeWithOptionsOther3 = {decodeWithOptions: v => Foreign$dGeneric$dClass.readString};
const ItemInfo = x => x;
const DiscountInfo = x => x;
const OrderInfo = x => x;
const toFillFormTypeOrderInfo = {fillFormDataType: v => "unknown"};
const toFillFormTypeItemInfo = {fillFormDataType: v => "unknown"};
const toFillFormTypeDiscountInf = {fillFormDataType: v => "unknown"};
const newtypeOrderInfo_ = {Coercible0: () => {}};
const newtypeItemInfo_ = {Coercible0: () => {}};
const newtypeDiscountInfo_ = {Coercible0: () => {}};
const hasFieldOrderInfo = dictHasField => dictHasField;
const hasFieldItemInfo = dictHasField => dictHasField;
const hasFieldDiscountInfo = dictHasField => dictHasField;
const eqItemInfo = {
  eq: x => y => (() => {
    if (x.category.tag === "Nothing") { return y.category.tag === "Nothing"; }
    if (x.category.tag === "Just") {
      if (y.category.tag === "Just") { return x.category._1 === y.category._1; }
      return false;
    }
    return false;
  })() && eq1(x.list)(y.list) && x.name === y.name && (() => {
    if (x.productId.tag === "Nothing") { return y.productId.tag === "Nothing"; }
    if (x.productId.tag === "Just") {
      if (y.productId.tag === "Just") { return x.productId._1 === y.productId._1; }
      return false;
    }
    return false;
  })() && x.promotion === y.promotion && x.quantity === y.quantity && (() => {
    if (x.rating.tag === "Nothing") { return y.rating.tag === "Nothing"; }
    if (x.rating.tag === "Just") {
      if (y.rating.tag === "Just") { return x.rating._1 === y.rating._1; }
      return false;
    }
    return false;
  })() && x.total === y.total && x.unitPrice === y.unitPrice
};
const eq19 = /* #__PURE__ */ (() => Data$dEq.eqArrayImpl(eqItemInfo.eq))();
const eqDiscountInfo = {eq: x => y => x.name === y.name && x.value === y.value};
const eq20 = /* #__PURE__ */ (() => Data$dEq.eqArrayImpl(eqDiscountInfo.eq))();
const eqOrderInfo = {
  eq: x => y => eq8(x.coupons)(y.coupons) && Data$dDateTime.eqDateTime.eq(x.createdAt)(y.createdAt) && (() => {
    if (x.currency.tag === "PLN") { return y.currency.tag === "PLN"; }
    if (x.currency.tag === "GBP") { return y.currency.tag === "GBP"; }
    if (x.currency.tag === "USD") { return y.currency.tag === "USD"; }
    if (x.currency.tag === "EUR") { return y.currency.tag === "EUR"; }
    if (x.currency.tag === "RUB") { return y.currency.tag === "RUB"; }
    if (x.currency.tag === "RON") { return y.currency.tag === "RON"; }
    if (x.currency.tag === "CZK") { return y.currency.tag === "CZK"; }
    if (x.currency.tag === "HRK") { return y.currency.tag === "HRK"; }
    if (x.currency.tag === "BRL") { return y.currency.tag === "BRL"; }
    if (x.currency.tag === "RSD") { return y.currency.tag === "RSD"; }
    return false;
  })() && x.customerTotal === y.customerTotal && eq11(x.deliveryAddress)(y.deliveryAddress) && x.deliveryCost === y.deliveryCost && (() => {
    if (x.deliveryRating.tag === "Nothing") { return y.deliveryRating.tag === "Nothing"; }
    if (x.deliveryRating.tag === "Just") {
      if (y.deliveryRating.tag === "Just") { return x.deliveryRating._1 === y.deliveryRating._1; }
      return false;
    }
    return false;
  })() && eq20(x.discounts)(y.discounts) && (() => {
    if (x.fulfillmentMethodType.tag === "Delivery") { return y.fulfillmentMethodType.tag === "Delivery"; }
    if (x.fulfillmentMethodType.tag === "Takeaway") { return y.fulfillmentMethodType.tag === "Takeaway"; }
    if (x.fulfillmentMethodType.tag === "DineIn") { return y.fulfillmentMethodType.tag === "DineIn"; }
    if (x.fulfillmentMethodType.tag === "NoContactDelivery") { return y.fulfillmentMethodType.tag === "NoContactDelivery"; }
    return false;
  })() && x.id === y.id && eq19(x.items)(y.items) && x.onlinePayment === y.onlinePayment && eq14(x.origin)(y.origin) && eq15(x.requestedFulfillmentTime)(y.requestedFulfillmentTime) && (() => {
    if (x.restaurantRating.tag === "Nothing") { return y.restaurantRating.tag === "Nothing"; }
    if (x.restaurantRating.tag === "Just") {
      if (y.restaurantRating.tag === "Just") { return x.restaurantRating._1 === y.restaurantRating._1; }
      return false;
    }
    return false;
  })() && x.restaurantTotal === y.restaurantTotal && x.timezone === y.timezone && (() => {
    if (x.tip.tag === "Nothing") { return y.tip.tag === "Nothing"; }
    if (x.tip.tag === "Just") {
      if (y.tip.tag === "Just") { return x.tip._1._1 === y.tip._1._1; }
      return false;
    }
    return false;
  })() && x.total === y.total && x.uuid === y.uuid
};
const genericOrderInfo = {to: x => x, from: x => x};
const genericItemInfo = {to: x => x, from: x => x};
const showItemInfo = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          if (v.category.tag === "Just") {
            return "{ category: (Just " + Data$dShow.showStringImpl(v.category._1) + ")" + (() => {
              if (v.list.tag === "Just") {
                return ", list: (Just " + Restaumatic$dAnalytics$dTypes$dItemList.showItemList.show(v.list._1) + ")" + ", name: " + Data$dShow.showStringImpl(v.name) + (() => {
                  if (v.productId.tag === "Just") {
                    return ", productId: (Just " + v.productId._1 + ")" + (v.promotion
                      ? ", promotion: true, quantity: " + Data$dShow.showIntImpl(v.quantity) + ", rating: " + showMaybe.show(v.rating) + ", total: " + Data$dMoney$dRounded.toString(v.total) + ", unitPrice: " + Data$dMoney$dRounded.toString(v.unitPrice) + " "
                      : ", promotion: false, quantity: " + Data$dShow.showIntImpl(v.quantity) + ", rating: " + showMaybe.show(v.rating) + ", total: " + Data$dMoney$dRounded.toString(v.total) + ", unitPrice: " + Data$dMoney$dRounded.toString(v.unitPrice) + " ");
                  }
                  if (v.productId.tag === "Nothing") {
                    if (v.promotion) {
                      return ", productId: Nothing, promotion: true, quantity: " + Data$dShow.showIntImpl(v.quantity) + ", rating: " + showMaybe.show(v.rating) + ", total: " + Data$dMoney$dRounded.toString(v.total) + ", unitPrice: " + Data$dMoney$dRounded.toString(v.unitPrice) + " ";
                    }
                    return ", productId: Nothing, promotion: false, quantity: " + Data$dShow.showIntImpl(v.quantity) + ", rating: " + showMaybe.show(v.rating) + ", total: " + Data$dMoney$dRounded.toString(v.total) + ", unitPrice: " + Data$dMoney$dRounded.toString(v.unitPrice) + " ";
                  }
                  $runtime.fail();
                })();
              }
              if (v.list.tag === "Nothing") {
                return ", list: Nothing, name: " + Data$dShow.showStringImpl(v.name) + (() => {
                  if (v.productId.tag === "Just") {
                    return ", productId: (Just " + v.productId._1 + ")" + (v.promotion
                      ? ", promotion: true, quantity: " + Data$dShow.showIntImpl(v.quantity) + ", rating: " + showMaybe.show(v.rating) + ", total: " + Data$dMoney$dRounded.toString(v.total) + ", unitPrice: " + Data$dMoney$dRounded.toString(v.unitPrice) + " "
                      : ", promotion: false, quantity: " + Data$dShow.showIntImpl(v.quantity) + ", rating: " + showMaybe.show(v.rating) + ", total: " + Data$dMoney$dRounded.toString(v.total) + ", unitPrice: " + Data$dMoney$dRounded.toString(v.unitPrice) + " ");
                  }
                  if (v.productId.tag === "Nothing") {
                    if (v.promotion) {
                      return ", productId: Nothing, promotion: true, quantity: " + Data$dShow.showIntImpl(v.quantity) + ", rating: " + showMaybe.show(v.rating) + ", total: " + Data$dMoney$dRounded.toString(v.total) + ", unitPrice: " + Data$dMoney$dRounded.toString(v.unitPrice) + " ";
                    }
                    return ", productId: Nothing, promotion: false, quantity: " + Data$dShow.showIntImpl(v.quantity) + ", rating: " + showMaybe.show(v.rating) + ", total: " + Data$dMoney$dRounded.toString(v.total) + ", unitPrice: " + Data$dMoney$dRounded.toString(v.unitPrice) + " ";
                  }
                  $runtime.fail();
                })();
              }
              $runtime.fail();
            })() + "}";
          }
          if (v.category.tag === "Nothing") {
            if (v.list.tag === "Just") {
              return "{ category: Nothing, list: (Just " + Restaumatic$dAnalytics$dTypes$dItemList.showItemList.show(v.list._1) + ")" + ", name: " + Data$dShow.showStringImpl(v.name) + (() => {
                if (v.productId.tag === "Just") {
                  return ", productId: (Just " + v.productId._1 + ")" + (v.promotion
                    ? ", promotion: true, quantity: " + Data$dShow.showIntImpl(v.quantity) + ", rating: " + showMaybe.show(v.rating) + ", total: " + Data$dMoney$dRounded.toString(v.total) + ", unitPrice: " + Data$dMoney$dRounded.toString(v.unitPrice) + " "
                    : ", promotion: false, quantity: " + Data$dShow.showIntImpl(v.quantity) + ", rating: " + showMaybe.show(v.rating) + ", total: " + Data$dMoney$dRounded.toString(v.total) + ", unitPrice: " + Data$dMoney$dRounded.toString(v.unitPrice) + " ");
                }
                if (v.productId.tag === "Nothing") {
                  if (v.promotion) {
                    return ", productId: Nothing, promotion: true, quantity: " + Data$dShow.showIntImpl(v.quantity) + ", rating: " + showMaybe.show(v.rating) + ", total: " + Data$dMoney$dRounded.toString(v.total) + ", unitPrice: " + Data$dMoney$dRounded.toString(v.unitPrice) + " ";
                  }
                  return ", productId: Nothing, promotion: false, quantity: " + Data$dShow.showIntImpl(v.quantity) + ", rating: " + showMaybe.show(v.rating) + ", total: " + Data$dMoney$dRounded.toString(v.total) + ", unitPrice: " + Data$dMoney$dRounded.toString(v.unitPrice) + " ";
                }
                $runtime.fail();
              })() + "}";
            }
            if (v.list.tag === "Nothing") {
              return "{ category: Nothing, list: Nothing, name: " + Data$dShow.showStringImpl(v.name) + (() => {
                if (v.productId.tag === "Just") {
                  return ", productId: (Just " + v.productId._1 + ")" + (v.promotion
                    ? ", promotion: true, quantity: " + Data$dShow.showIntImpl(v.quantity) + ", rating: " + showMaybe.show(v.rating) + ", total: " + Data$dMoney$dRounded.toString(v.total) + ", unitPrice: " + Data$dMoney$dRounded.toString(v.unitPrice) + " "
                    : ", promotion: false, quantity: " + Data$dShow.showIntImpl(v.quantity) + ", rating: " + showMaybe.show(v.rating) + ", total: " + Data$dMoney$dRounded.toString(v.total) + ", unitPrice: " + Data$dMoney$dRounded.toString(v.unitPrice) + " ");
                }
                if (v.productId.tag === "Nothing") {
                  if (v.promotion) {
                    return ", productId: Nothing, promotion: true, quantity: " + Data$dShow.showIntImpl(v.quantity) + ", rating: " + showMaybe.show(v.rating) + ", total: " + Data$dMoney$dRounded.toString(v.total) + ", unitPrice: " + Data$dMoney$dRounded.toString(v.unitPrice) + " ";
                  }
                  return ", productId: Nothing, promotion: false, quantity: " + Data$dShow.showIntImpl(v.quantity) + ", rating: " + showMaybe.show(v.rating) + ", total: " + Data$dMoney$dRounded.toString(v.total) + ", unitPrice: " + Data$dMoney$dRounded.toString(v.unitPrice) + " ";
                }
                $runtime.fail();
              })() + "}";
            }
            $runtime.fail();
          }
          $runtime.fail();
        })()
      ]
    })(ItemInfoIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeItemInfo = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(categoryIsSymbol)(Unscramble.decodeMaybe(Unscramble.decodeString1))(Unscramble.decodeRecordCons(listIsSymbol)(Unscramble.decodeMaybe(Restaumatic$dAnalytics$dTypes$dItemList.unscrambleDecodeItemList))(decodeRecordCons(Unscramble.decodeRecordCons(productIdIsSymbol)(Unscramble.decodeMaybe(Data$dUUID.udecodeUUID))(Unscramble.decodeRecordCons(promotionIsSymbol)(Unscramble.decodeBoolean1)(Unscramble.decodeRecordCons(quantityIsSymbol)(Unscramble.decodeInt1)(Unscramble.decodeRecordCons(ratingIsSymbol)(decodeMaybe)(decodeRecordCons1(Unscramble.decodeRecordCons(unitPriceIsSymbol)(Data$dMoney$dRounded.udecodeMoney)(Unscramble.decodeRecordNil))))))))).recordInfo(Type$dProxy.Proxy))
  }
))();
const genericDiscountInfo = {to: x => x, from: x => x};
const showDiscountInfo = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => ["{ name: " + Data$dShow.showStringImpl(v.name) + ", value: " + Data$dMoney$dRounded.toString(v.value) + " " + "}"]
    })(DiscountInfoIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const showOrderInfo = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Data$dShow.showArrayImpl(showItemInfo.show);
      const $1 = Data$dShow.showArrayImpl(showDiscountInfo.show);
      const $2 = Data$dShow.showArrayImpl(Restaumatic$dOrders$dTypes$dCoupon.showCoupon.show);
      return {
        genericShowArgs: v => [
          "{ coupons: " + $2(v.coupons) + ", createdAt: " + DateUtils.formatISODateTime(v.createdAt) + ", currency: " + Restaumatic$dCurrencies.showCurrency.show(v.currency) + ", customerTotal: " + Data$dMoney$dRounded.toString(v.customerTotal) + (() => {
            if (v.deliveryAddress.tag === "Just") {
              return ", deliveryAddress: (Just " + Restaumatic$dGeocoding$dTypes$dDeliveryAddress.showDeliveryAddress.show(v.deliveryAddress._1) + ")" + ", deliveryCost: " + Data$dMoney$dRounded.toString(v.deliveryCost) + ", deliveryRating: " + showMaybe.show(v.deliveryRating) + ", discounts: " + $1(v.discounts) + ", fulfillmentMethodType: " + Restaumatic$dOrders$dTypes$dFulfillmentMethodType.showFulfillmentMethodType.show(v.fulfillmentMethodType) + ", id: " + Data$dShow.showIntImpl(v.id) + ", items: " + $0(v.items) + (() => {
                if (v.onlinePayment) {
                  if (v.origin.tag === "Just") {
                    return ", onlinePayment: true, origin: (Just " + Restaumatic$dOrders$dTypes$dOrderOrigin.showOrderOrigin.show(v.origin._1) + ")" + (() => {
                      if (v.requestedFulfillmentTime.tag === "Just") {
                        return ", requestedFulfillmentTime: (Just " + DateUtils.formatISODateTime(v.requestedFulfillmentTime._1) + ")" + ", restaurantRating: " + showMaybe.show(v.restaurantRating) + ", restaurantTotal: " + Data$dMoney$dRounded.toString(v.restaurantTotal) + ", timezone: " + Data$dShow.showStringImpl(v.timezone) + (() => {
                          if (v.tip.tag === "Just") {
                            return ", tip: (Just " + Restaumatic$dOrders$dTypes$dTip.showTip.show(v.tip._1) + ")" + ", total: " + Data$dMoney$dRounded.toString(v.total) + ", uuid: " + Restaumatic$dOrders$dTypes$dOrderUUID.showOrderUUID.show(v.uuid) + " ";
                          }
                          if (v.tip.tag === "Nothing") {
                            return ", tip: Nothing, total: " + Data$dMoney$dRounded.toString(v.total) + ", uuid: " + Restaumatic$dOrders$dTypes$dOrderUUID.showOrderUUID.show(v.uuid) + " ";
                          }
                          $runtime.fail();
                        })();
                      }
                      if (v.requestedFulfillmentTime.tag === "Nothing") {
                        return ", requestedFulfillmentTime: Nothing, restaurantRating: " + showMaybe.show(v.restaurantRating) + ", restaurantTotal: " + Data$dMoney$dRounded.toString(v.restaurantTotal) + ", timezone: " + Data$dShow.showStringImpl(v.timezone) + (() => {
                          if (v.tip.tag === "Just") {
                            return ", tip: (Just " + Restaumatic$dOrders$dTypes$dTip.showTip.show(v.tip._1) + ")" + ", total: " + Data$dMoney$dRounded.toString(v.total) + ", uuid: " + Restaumatic$dOrders$dTypes$dOrderUUID.showOrderUUID.show(v.uuid) + " ";
                          }
                          if (v.tip.tag === "Nothing") {
                            return ", tip: Nothing, total: " + Data$dMoney$dRounded.toString(v.total) + ", uuid: " + Restaumatic$dOrders$dTypes$dOrderUUID.showOrderUUID.show(v.uuid) + " ";
                          }
                          $runtime.fail();
                        })();
                      }
                      $runtime.fail();
                    })();
                  }
                  if (v.origin.tag === "Nothing") {
                    if (v.requestedFulfillmentTime.tag === "Just") {
                      return ", onlinePayment: true, origin: Nothing, requestedFulfillmentTime: (Just " + DateUtils.formatISODateTime(v.requestedFulfillmentTime._1) + ")" + ", restaurantRating: " + showMaybe.show(v.restaurantRating) + ", restaurantTotal: " + Data$dMoney$dRounded.toString(v.restaurantTotal) + ", timezone: " + Data$dShow.showStringImpl(v.timezone) + (() => {
                        if (v.tip.tag === "Just") {
                          return ", tip: (Just " + Restaumatic$dOrders$dTypes$dTip.showTip.show(v.tip._1) + ")" + ", total: " + Data$dMoney$dRounded.toString(v.total) + ", uuid: " + Restaumatic$dOrders$dTypes$dOrderUUID.showOrderUUID.show(v.uuid) + " ";
                        }
                        if (v.tip.tag === "Nothing") {
                          return ", tip: Nothing, total: " + Data$dMoney$dRounded.toString(v.total) + ", uuid: " + Restaumatic$dOrders$dTypes$dOrderUUID.showOrderUUID.show(v.uuid) + " ";
                        }
                        $runtime.fail();
                      })();
                    }
                    if (v.requestedFulfillmentTime.tag === "Nothing") {
                      return ", onlinePayment: true, origin: Nothing, requestedFulfillmentTime: Nothing, restaurantRating: " + showMaybe.show(v.restaurantRating) + ", restaurantTotal: " + Data$dMoney$dRounded.toString(v.restaurantTotal) + ", timezone: " + Data$dShow.showStringImpl(v.timezone) + (() => {
                        if (v.tip.tag === "Just") {
                          return ", tip: (Just " + Restaumatic$dOrders$dTypes$dTip.showTip.show(v.tip._1) + ")" + ", total: " + Data$dMoney$dRounded.toString(v.total) + ", uuid: " + Restaumatic$dOrders$dTypes$dOrderUUID.showOrderUUID.show(v.uuid) + " ";
                        }
                        if (v.tip.tag === "Nothing") {
                          return ", tip: Nothing, total: " + Data$dMoney$dRounded.toString(v.total) + ", uuid: " + Restaumatic$dOrders$dTypes$dOrderUUID.showOrderUUID.show(v.uuid) + " ";
                        }
                        $runtime.fail();
                      })();
                    }
                    $runtime.fail();
                  }
                  $runtime.fail();
                }
                if (v.origin.tag === "Just") {
                  return ", onlinePayment: false, origin: (Just " + Restaumatic$dOrders$dTypes$dOrderOrigin.showOrderOrigin.show(v.origin._1) + ")" + (() => {
                    if (v.requestedFulfillmentTime.tag === "Just") {
                      return ", requestedFulfillmentTime: (Just " + DateUtils.formatISODateTime(v.requestedFulfillmentTime._1) + ")" + ", restaurantRating: " + showMaybe.show(v.restaurantRating) + ", restaurantTotal: " + Data$dMoney$dRounded.toString(v.restaurantTotal) + ", timezone: " + Data$dShow.showStringImpl(v.timezone) + (() => {
                        if (v.tip.tag === "Just") {
                          return ", tip: (Just " + Restaumatic$dOrders$dTypes$dTip.showTip.show(v.tip._1) + ")" + ", total: " + Data$dMoney$dRounded.toString(v.total) + ", uuid: " + Restaumatic$dOrders$dTypes$dOrderUUID.showOrderUUID.show(v.uuid) + " ";
                        }
                        if (v.tip.tag === "Nothing") {
                          return ", tip: Nothing, total: " + Data$dMoney$dRounded.toString(v.total) + ", uuid: " + Restaumatic$dOrders$dTypes$dOrderUUID.showOrderUUID.show(v.uuid) + " ";
                        }
                        $runtime.fail();
                      })();
                    }
                    if (v.requestedFulfillmentTime.tag === "Nothing") {
                      return ", requestedFulfillmentTime: Nothing, restaurantRating: " + showMaybe.show(v.restaurantRating) + ", restaurantTotal: " + Data$dMoney$dRounded.toString(v.restaurantTotal) + ", timezone: " + Data$dShow.showStringImpl(v.timezone) + (() => {
                        if (v.tip.tag === "Just") {
                          return ", tip: (Just " + Restaumatic$dOrders$dTypes$dTip.showTip.show(v.tip._1) + ")" + ", total: " + Data$dMoney$dRounded.toString(v.total) + ", uuid: " + Restaumatic$dOrders$dTypes$dOrderUUID.showOrderUUID.show(v.uuid) + " ";
                        }
                        if (v.tip.tag === "Nothing") {
                          return ", tip: Nothing, total: " + Data$dMoney$dRounded.toString(v.total) + ", uuid: " + Restaumatic$dOrders$dTypes$dOrderUUID.showOrderUUID.show(v.uuid) + " ";
                        }
                        $runtime.fail();
                      })();
                    }
                    $runtime.fail();
                  })();
                }
                if (v.origin.tag === "Nothing") {
                  if (v.requestedFulfillmentTime.tag === "Just") {
                    return ", onlinePayment: false, origin: Nothing, requestedFulfillmentTime: (Just " + DateUtils.formatISODateTime(v.requestedFulfillmentTime._1) + ")" + ", restaurantRating: " + showMaybe.show(v.restaurantRating) + ", restaurantTotal: " + Data$dMoney$dRounded.toString(v.restaurantTotal) + ", timezone: " + Data$dShow.showStringImpl(v.timezone) + (() => {
                      if (v.tip.tag === "Just") {
                        return ", tip: (Just " + Restaumatic$dOrders$dTypes$dTip.showTip.show(v.tip._1) + ")" + ", total: " + Data$dMoney$dRounded.toString(v.total) + ", uuid: " + Restaumatic$dOrders$dTypes$dOrderUUID.showOrderUUID.show(v.uuid) + " ";
                      }
                      if (v.tip.tag === "Nothing") {
                        return ", tip: Nothing, total: " + Data$dMoney$dRounded.toString(v.total) + ", uuid: " + Restaumatic$dOrders$dTypes$dOrderUUID.showOrderUUID.show(v.uuid) + " ";
                      }
                      $runtime.fail();
                    })();
                  }
                  if (v.requestedFulfillmentTime.tag === "Nothing") {
                    return ", onlinePayment: false, origin: Nothing, requestedFulfillmentTime: Nothing, restaurantRating: " + showMaybe.show(v.restaurantRating) + ", restaurantTotal: " + Data$dMoney$dRounded.toString(v.restaurantTotal) + ", timezone: " + Data$dShow.showStringImpl(v.timezone) + (() => {
                      if (v.tip.tag === "Just") {
                        return ", tip: (Just " + Restaumatic$dOrders$dTypes$dTip.showTip.show(v.tip._1) + ")" + ", total: " + Data$dMoney$dRounded.toString(v.total) + ", uuid: " + Restaumatic$dOrders$dTypes$dOrderUUID.showOrderUUID.show(v.uuid) + " ";
                      }
                      if (v.tip.tag === "Nothing") {
                        return ", tip: Nothing, total: " + Data$dMoney$dRounded.toString(v.total) + ", uuid: " + Restaumatic$dOrders$dTypes$dOrderUUID.showOrderUUID.show(v.uuid) + " ";
                      }
                      $runtime.fail();
                    })();
                  }
                  $runtime.fail();
                }
                $runtime.fail();
              })();
            }
            if (v.deliveryAddress.tag === "Nothing") {
              return ", deliveryAddress: Nothing, deliveryCost: " + Data$dMoney$dRounded.toString(v.deliveryCost) + ", deliveryRating: " + showMaybe.show(v.deliveryRating) + ", discounts: " + $1(v.discounts) + ", fulfillmentMethodType: " + Restaumatic$dOrders$dTypes$dFulfillmentMethodType.showFulfillmentMethodType.show(v.fulfillmentMethodType) + ", id: " + Data$dShow.showIntImpl(v.id) + ", items: " + $0(v.items) + (() => {
                if (v.onlinePayment) {
                  if (v.origin.tag === "Just") {
                    return ", onlinePayment: true, origin: (Just " + Restaumatic$dOrders$dTypes$dOrderOrigin.showOrderOrigin.show(v.origin._1) + ")" + (() => {
                      if (v.requestedFulfillmentTime.tag === "Just") {
                        return ", requestedFulfillmentTime: (Just " + DateUtils.formatISODateTime(v.requestedFulfillmentTime._1) + ")" + ", restaurantRating: " + showMaybe.show(v.restaurantRating) + ", restaurantTotal: " + Data$dMoney$dRounded.toString(v.restaurantTotal) + ", timezone: " + Data$dShow.showStringImpl(v.timezone) + (() => {
                          if (v.tip.tag === "Just") {
                            return ", tip: (Just " + Restaumatic$dOrders$dTypes$dTip.showTip.show(v.tip._1) + ")" + ", total: " + Data$dMoney$dRounded.toString(v.total) + ", uuid: " + Restaumatic$dOrders$dTypes$dOrderUUID.showOrderUUID.show(v.uuid) + " ";
                          }
                          if (v.tip.tag === "Nothing") {
                            return ", tip: Nothing, total: " + Data$dMoney$dRounded.toString(v.total) + ", uuid: " + Restaumatic$dOrders$dTypes$dOrderUUID.showOrderUUID.show(v.uuid) + " ";
                          }
                          $runtime.fail();
                        })();
                      }
                      if (v.requestedFulfillmentTime.tag === "Nothing") {
                        return ", requestedFulfillmentTime: Nothing, restaurantRating: " + showMaybe.show(v.restaurantRating) + ", restaurantTotal: " + Data$dMoney$dRounded.toString(v.restaurantTotal) + ", timezone: " + Data$dShow.showStringImpl(v.timezone) + (() => {
                          if (v.tip.tag === "Just") {
                            return ", tip: (Just " + Restaumatic$dOrders$dTypes$dTip.showTip.show(v.tip._1) + ")" + ", total: " + Data$dMoney$dRounded.toString(v.total) + ", uuid: " + Restaumatic$dOrders$dTypes$dOrderUUID.showOrderUUID.show(v.uuid) + " ";
                          }
                          if (v.tip.tag === "Nothing") {
                            return ", tip: Nothing, total: " + Data$dMoney$dRounded.toString(v.total) + ", uuid: " + Restaumatic$dOrders$dTypes$dOrderUUID.showOrderUUID.show(v.uuid) + " ";
                          }
                          $runtime.fail();
                        })();
                      }
                      $runtime.fail();
                    })();
                  }
                  if (v.origin.tag === "Nothing") {
                    if (v.requestedFulfillmentTime.tag === "Just") {
                      return ", onlinePayment: true, origin: Nothing, requestedFulfillmentTime: (Just " + DateUtils.formatISODateTime(v.requestedFulfillmentTime._1) + ")" + ", restaurantRating: " + showMaybe.show(v.restaurantRating) + ", restaurantTotal: " + Data$dMoney$dRounded.toString(v.restaurantTotal) + ", timezone: " + Data$dShow.showStringImpl(v.timezone) + (() => {
                        if (v.tip.tag === "Just") {
                          return ", tip: (Just " + Restaumatic$dOrders$dTypes$dTip.showTip.show(v.tip._1) + ")" + ", total: " + Data$dMoney$dRounded.toString(v.total) + ", uuid: " + Restaumatic$dOrders$dTypes$dOrderUUID.showOrderUUID.show(v.uuid) + " ";
                        }
                        if (v.tip.tag === "Nothing") {
                          return ", tip: Nothing, total: " + Data$dMoney$dRounded.toString(v.total) + ", uuid: " + Restaumatic$dOrders$dTypes$dOrderUUID.showOrderUUID.show(v.uuid) + " ";
                        }
                        $runtime.fail();
                      })();
                    }
                    if (v.requestedFulfillmentTime.tag === "Nothing") {
                      return ", onlinePayment: true, origin: Nothing, requestedFulfillmentTime: Nothing, restaurantRating: " + showMaybe.show(v.restaurantRating) + ", restaurantTotal: " + Data$dMoney$dRounded.toString(v.restaurantTotal) + ", timezone: " + Data$dShow.showStringImpl(v.timezone) + (() => {
                        if (v.tip.tag === "Just") {
                          return ", tip: (Just " + Restaumatic$dOrders$dTypes$dTip.showTip.show(v.tip._1) + ")" + ", total: " + Data$dMoney$dRounded.toString(v.total) + ", uuid: " + Restaumatic$dOrders$dTypes$dOrderUUID.showOrderUUID.show(v.uuid) + " ";
                        }
                        if (v.tip.tag === "Nothing") {
                          return ", tip: Nothing, total: " + Data$dMoney$dRounded.toString(v.total) + ", uuid: " + Restaumatic$dOrders$dTypes$dOrderUUID.showOrderUUID.show(v.uuid) + " ";
                        }
                        $runtime.fail();
                      })();
                    }
                    $runtime.fail();
                  }
                  $runtime.fail();
                }
                if (v.origin.tag === "Just") {
                  return ", onlinePayment: false, origin: (Just " + Restaumatic$dOrders$dTypes$dOrderOrigin.showOrderOrigin.show(v.origin._1) + ")" + (() => {
                    if (v.requestedFulfillmentTime.tag === "Just") {
                      return ", requestedFulfillmentTime: (Just " + DateUtils.formatISODateTime(v.requestedFulfillmentTime._1) + ")" + ", restaurantRating: " + showMaybe.show(v.restaurantRating) + ", restaurantTotal: " + Data$dMoney$dRounded.toString(v.restaurantTotal) + ", timezone: " + Data$dShow.showStringImpl(v.timezone) + (() => {
                        if (v.tip.tag === "Just") {
                          return ", tip: (Just " + Restaumatic$dOrders$dTypes$dTip.showTip.show(v.tip._1) + ")" + ", total: " + Data$dMoney$dRounded.toString(v.total) + ", uuid: " + Restaumatic$dOrders$dTypes$dOrderUUID.showOrderUUID.show(v.uuid) + " ";
                        }
                        if (v.tip.tag === "Nothing") {
                          return ", tip: Nothing, total: " + Data$dMoney$dRounded.toString(v.total) + ", uuid: " + Restaumatic$dOrders$dTypes$dOrderUUID.showOrderUUID.show(v.uuid) + " ";
                        }
                        $runtime.fail();
                      })();
                    }
                    if (v.requestedFulfillmentTime.tag === "Nothing") {
                      return ", requestedFulfillmentTime: Nothing, restaurantRating: " + showMaybe.show(v.restaurantRating) + ", restaurantTotal: " + Data$dMoney$dRounded.toString(v.restaurantTotal) + ", timezone: " + Data$dShow.showStringImpl(v.timezone) + (() => {
                        if (v.tip.tag === "Just") {
                          return ", tip: (Just " + Restaumatic$dOrders$dTypes$dTip.showTip.show(v.tip._1) + ")" + ", total: " + Data$dMoney$dRounded.toString(v.total) + ", uuid: " + Restaumatic$dOrders$dTypes$dOrderUUID.showOrderUUID.show(v.uuid) + " ";
                        }
                        if (v.tip.tag === "Nothing") {
                          return ", tip: Nothing, total: " + Data$dMoney$dRounded.toString(v.total) + ", uuid: " + Restaumatic$dOrders$dTypes$dOrderUUID.showOrderUUID.show(v.uuid) + " ";
                        }
                        $runtime.fail();
                      })();
                    }
                    $runtime.fail();
                  })();
                }
                if (v.origin.tag === "Nothing") {
                  if (v.requestedFulfillmentTime.tag === "Just") {
                    return ", onlinePayment: false, origin: Nothing, requestedFulfillmentTime: (Just " + DateUtils.formatISODateTime(v.requestedFulfillmentTime._1) + ")" + ", restaurantRating: " + showMaybe.show(v.restaurantRating) + ", restaurantTotal: " + Data$dMoney$dRounded.toString(v.restaurantTotal) + ", timezone: " + Data$dShow.showStringImpl(v.timezone) + (() => {
                      if (v.tip.tag === "Just") {
                        return ", tip: (Just " + Restaumatic$dOrders$dTypes$dTip.showTip.show(v.tip._1) + ")" + ", total: " + Data$dMoney$dRounded.toString(v.total) + ", uuid: " + Restaumatic$dOrders$dTypes$dOrderUUID.showOrderUUID.show(v.uuid) + " ";
                      }
                      if (v.tip.tag === "Nothing") {
                        return ", tip: Nothing, total: " + Data$dMoney$dRounded.toString(v.total) + ", uuid: " + Restaumatic$dOrders$dTypes$dOrderUUID.showOrderUUID.show(v.uuid) + " ";
                      }
                      $runtime.fail();
                    })();
                  }
                  if (v.requestedFulfillmentTime.tag === "Nothing") {
                    return ", onlinePayment: false, origin: Nothing, requestedFulfillmentTime: Nothing, restaurantRating: " + showMaybe.show(v.restaurantRating) + ", restaurantTotal: " + Data$dMoney$dRounded.toString(v.restaurantTotal) + ", timezone: " + Data$dShow.showStringImpl(v.timezone) + (() => {
                      if (v.tip.tag === "Just") {
                        return ", tip: (Just " + Restaumatic$dOrders$dTypes$dTip.showTip.show(v.tip._1) + ")" + ", total: " + Data$dMoney$dRounded.toString(v.total) + ", uuid: " + Restaumatic$dOrders$dTypes$dOrderUUID.showOrderUUID.show(v.uuid) + " ";
                      }
                      if (v.tip.tag === "Nothing") {
                        return ", tip: Nothing, total: " + Data$dMoney$dRounded.toString(v.total) + ", uuid: " + Restaumatic$dOrders$dTypes$dOrderUUID.showOrderUUID.show(v.uuid) + " ";
                      }
                      $runtime.fail();
                    })();
                  }
                  $runtime.fail();
                }
                $runtime.fail();
              })();
            }
            $runtime.fail();
          })() + "}"
        ]
      };
    })())(OrderInfoIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeDiscountInfo = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(decodeRecordCons(Unscramble.decodeRecordCons(valueIsSymbol)(Data$dMoney$dRounded.udecodeMoney)(Unscramble.decodeRecordNil)).recordInfo(Type$dProxy.Proxy))
  }
))();
const unscrambleDecodeOrderInfo = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(couponsIsSymbol)({
      unsafeDecode: Unscramble.decodeArray(Restaumatic$dOrders$dTypes$dCoupon.unscrambleDecodeCoupon.unsafeDecode)
    })(Unscramble.decodeRecordCons(createdAtIsSymbol)(Data$dUTCTime.unscrambleDecodeUTCTime)(Unscramble.decodeRecordCons(currencyIsSymbol)(Restaumatic$dCurrencies.unscrambleDecodeCurrency)(Unscramble.decodeRecordCons(customerTotalIsSymbol)(Data$dMoney$dRounded.udecodeMoney)(Unscramble.decodeRecordCons(deliveryAddressIsSymbol)(Unscramble.decodeMaybe(Restaumatic$dGeocoding$dTypes$dDeliveryAddress.unscrambleDecodeDeliveryAddress))(Unscramble.decodeRecordCons(deliveryCostIsSymbol)(Data$dMoney$dRounded.udecodeMoney)(Unscramble.decodeRecordCons(deliveryRatingIsSymbol)(decodeMaybe)(Unscramble.decodeRecordCons(discountsIsSymbol)({
      unsafeDecode: Unscramble.decodeArray(unscrambleDecodeDiscountInfo.unsafeDecode)
    })(Unscramble.decodeRecordCons(fulfillmentMethodTypeIsSymbol)(Restaumatic$dOrders$dTypes$dFulfillmentMethodType.unscrambleDecodeFulfillmentMethodType)(Unscramble.decodeRecordCons(idIsSymbol)(Unscramble.decodeInt1)(Unscramble.decodeRecordCons(itemsIsSymbol)({
      unsafeDecode: Unscramble.decodeArray(unscrambleDecodeItemInfo.unsafeDecode)
    })(Unscramble.decodeRecordCons(onlinePaymentIsSymbol)(Unscramble.decodeBoolean1)(Unscramble.decodeRecordCons(originIsSymbol)(Unscramble.decodeMaybe(Restaumatic$dOrders$dTypes$dOrderOrigin.unscrambleDecodeOrderOrigin))(Unscramble.decodeRecordCons(requestedFulfillmentTimeIsSymbol)(Unscramble.decodeMaybe(Data$dUTCTime.unscrambleDecodeUTCTime))(Unscramble.decodeRecordCons(restaurantRatingIsSymbol)(decodeMaybe)(Unscramble.decodeRecordCons(restaurantTotalIsSymbol)(Data$dMoney$dRounded.udecodeMoney)(Unscramble.decodeRecordCons(timezoneIsSymbol)(Data$dTime$dLocal.udecodeTZLabel)(Unscramble.decodeRecordCons(tipIsSymbol)(Unscramble.decodeMaybe(Restaumatic$dOrders$dTypes$dTip.unscrambleDecodeTip))(decodeRecordCons1(Unscramble.decodeRecordCons(uuidIsSymbol)(Restaumatic$dOrders$dTypes$dOrderUUID.unscrambleDecodeOrderUUID)(Unscramble.decodeRecordNil)))))))))))))))))))).recordInfo(Type$dProxy.Proxy))
  }
))();
const encodeItemInfo = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericItemInfo)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(ItemInfoIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(unitPriceIsSymbol)(encodeWithOptionsOther))(totalIsSymbol)(encodeWithOptionsOther))(ratingIsSymbol)(encodeWithOptionsOther1))(quantityIsSymbol)({
      encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce
    }))(promotionIsSymbol)(encodeWithOptionsOther2))(productIdIsSymbol)({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return v2._1; }
        $runtime.fail();
      }
    }))(nameIsSymbol)(encodeWithOptionsOther3))(listIsSymbol)({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return Restaumatic$dAnalytics$dTypes$dItemList.encodeItemList.encode(v2._1); }
        $runtime.fail();
      }
    }))(categoryIsSymbol)({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return v2._1; }
        $runtime.fail();
      }
    });
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const encodeDiscountInfo = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericDiscountInfo)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(DiscountInfoIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(valueIsSymbol)(encodeWithOptionsOther))(nameIsSymbol)(encodeWithOptionsOther3);
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const encodeOrderInfo = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericOrderInfo)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(OrderInfoIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(uuidIsSymbol)({
      encodeWithOptions: v => Restaumatic$dOrders$dTypes$dOrderUUID.encodeOrderUUID.encode
    }))(totalIsSymbol)(encodeWithOptionsOther))(tipIsSymbol)({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return Restaumatic$dOrders$dTypes$dTip.encodeTip.encode(v2._1); }
        $runtime.fail();
      }
    }))(timezoneIsSymbol)({encodeWithOptions: v => Data$dTime$dLocal.encodeTZLabel.encode}))(restaurantTotalIsSymbol)(encodeWithOptionsOther))(restaurantRatingIsSymbol)(encodeWithOptionsOther1))(requestedFulfillmentTimeIsSymbol)({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return DateUtils.formatISODateTime(v2._1); }
        $runtime.fail();
      }
    }))(originIsSymbol)({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return Restaumatic$dOrders$dTypes$dOrderOrigin.encodeOrderOrigin.encode(v2._1); }
        $runtime.fail();
      }
    }))(onlinePaymentIsSymbol)(encodeWithOptionsOther2))(itemsIsSymbol)((() => {
      const encode1 = Data$dFunctor.arrayMap(encodeItemInfo.encode);
      return {encodeWithOptions: v => encode1};
    })()))(idIsSymbol)({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))(fulfillmentMethodTypeIsSymbol)({
      encodeWithOptions: v => Restaumatic$dOrders$dTypes$dFulfillmentMethodType.encodeFulfillmentMethodType.encode
    }))(discountsIsSymbol)((() => {
      const encode1 = Data$dFunctor.arrayMap(encodeDiscountInfo.encode);
      return {encodeWithOptions: v => encode1};
    })()))(deliveryRatingIsSymbol)(encodeWithOptionsOther1))(deliveryCostIsSymbol)(encodeWithOptionsOther))(deliveryAddressIsSymbol)({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return Restaumatic$dGeocoding$dTypes$dDeliveryAddress.encodeDeliveryAddress.encode(v2._1); }
        $runtime.fail();
      }
    }))(customerTotalIsSymbol)(encodeWithOptionsOther))(currencyIsSymbol)({encodeWithOptions: v => Restaumatic$dCurrencies.encodeCurrency.encode}))(createdAtIsSymbol)({
      encodeWithOptions: v => Data$dUTCTime.encodeUTCTime.encode
    }))(couponsIsSymbol)((() => {
      const encode1 = Data$dFunctor.arrayMap(Restaumatic$dOrders$dTypes$dCoupon.encodeCoupon.encode);
      return {encodeWithOptions: v => encode1};
    })());
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const decodeItemInfo = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericItemInfo)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(ItemInfoIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(unitPriceIsSymbol)(decodeWithOptionsOther)())(totalIsSymbol)(decodeWithOptionsOther)())(ratingIsSymbol)(decodeWithOptionsOther1)())(quantityIsSymbol)({
    decodeWithOptions: v => Foreign$dGeneric$dClass.intDecode.decode
  })())(promotionIsSymbol)(decodeWithOptionsOther2)())(productIdIsSymbol)({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Data$dUUID.decodeUUID.decode)})())(nameIsSymbol)(decodeWithOptionsOther3)())(listIsSymbol)({
    decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Restaumatic$dAnalytics$dTypes$dItemList.decodeItemList.decode)
  })())(categoryIsSymbol)({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign$dGeneric$dClass.readString)})())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
const decodeDiscountInfo = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericDiscountInfo)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(DiscountInfoIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(valueIsSymbol)(decodeWithOptionsOther)())(nameIsSymbol)(decodeWithOptionsOther3)())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
const decodeOrderInfo = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericOrderInfo)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(OrderInfoIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(uuidIsSymbol)({
    decodeWithOptions: v => Restaumatic$dOrders$dTypes$dOrderUUID.decodeOrderUUID.decode
  })())(totalIsSymbol)(decodeWithOptionsOther)())(tipIsSymbol)({
    decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Restaumatic$dOrders$dTypes$dTip.decodeTip.decode)
  })())(timezoneIsSymbol)({decodeWithOptions: v => Data$dTime$dLocal.decodeTZLabel.decode})())(restaurantTotalIsSymbol)(decodeWithOptionsOther)())(restaurantRatingIsSymbol)(decodeWithOptionsOther1)())(requestedFulfillmentTimeIsSymbol)({
    decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Data$dUTCTime.decodeUTCTime.decode)
  })())(originIsSymbol)({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Restaumatic$dOrders$dTypes$dOrderOrigin.decodeOrderOrigin.decode)})())(onlinePaymentIsSymbol)(decodeWithOptionsOther2)())(itemsIsSymbol)(/* #__PURE__ */ (() => {
    const decode2 = Foreign$dGeneric$dClass.arrayDecode(decodeItemInfo).decode;
    return {decodeWithOptions: v => decode2};
  })())())(idIsSymbol)({decodeWithOptions: v => Foreign$dGeneric$dClass.intDecode.decode})())(fulfillmentMethodTypeIsSymbol)({
    decodeWithOptions: v => Restaumatic$dOrders$dTypes$dFulfillmentMethodType.decodeFulfillmentMethodType.decode
  })())(discountsIsSymbol)(/* #__PURE__ */ (() => {
    const decode2 = Foreign$dGeneric$dClass.arrayDecode(decodeDiscountInfo).decode;
    return {decodeWithOptions: v => decode2};
  })())())(deliveryRatingIsSymbol)(decodeWithOptionsOther1)())(deliveryCostIsSymbol)(decodeWithOptionsOther)())(deliveryAddressIsSymbol)({
    decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Restaumatic$dGeocoding$dTypes$dDeliveryAddress.decodeDeliveryAddress.decode)
  })())(customerTotalIsSymbol)(decodeWithOptionsOther)())(currencyIsSymbol)({decodeWithOptions: v => Restaumatic$dCurrencies.decodeCurrency.decode})())(createdAtIsSymbol)({
    decodeWithOptions: v => Data$dUTCTime.decodeUTCTime.decode
  })())(couponsIsSymbol)(/* #__PURE__ */ (() => {
    const decode2 = Foreign$dGeneric$dClass.arrayDecode(Restaumatic$dOrders$dTypes$dCoupon.decodeCoupon).decode;
    return {decodeWithOptions: v => decode2};
  })())())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
export {
  DiscountInfo,
  DiscountInfoIsSymbol,
  ItemInfo,
  ItemInfoIsSymbol,
  OrderInfo,
  OrderInfoIsSymbol,
  categoryIsSymbol,
  couponsIsSymbol,
  createdAtIsSymbol,
  currencyIsSymbol,
  customerTotalIsSymbol,
  decodeDiscountInfo,
  decodeItemInfo,
  decodeMaybe,
  decodeOrderInfo,
  decodeRecordCons,
  decodeRecordCons1,
  decodeWithOptionsOther,
  decodeWithOptionsOther1,
  decodeWithOptionsOther2,
  decodeWithOptionsOther3,
  deliveryAddressIsSymbol,
  deliveryCostIsSymbol,
  deliveryRatingIsSymbol,
  discountsIsSymbol,
  encodeDiscountInfo,
  encodeItemInfo,
  encodeOrderInfo,
  encodeWithOptionsOther,
  encodeWithOptionsOther1,
  encodeWithOptionsOther2,
  encodeWithOptionsOther3,
  eq1,
  eq11,
  eq14,
  eq15,
  eq19,
  eq20,
  eq8,
  eqDiscountInfo,
  eqItemInfo,
  eqOrderInfo,
  fulfillmentMethodTypeIsSymbol,
  genericDiscountInfo,
  genericItemInfo,
  genericOrderInfo,
  hasFieldDiscountInfo,
  hasFieldItemInfo,
  hasFieldOrderInfo,
  idIsSymbol,
  itemsIsSymbol,
  listIsSymbol,
  nameIsSymbol,
  newtypeDiscountInfo_,
  newtypeItemInfo_,
  newtypeOrderInfo_,
  onlinePaymentIsSymbol,
  originIsSymbol,
  productIdIsSymbol,
  promotionIsSymbol,
  quantityIsSymbol,
  ratingIsSymbol,
  requestedFulfillmentTimeIsSymbol,
  restaurantRatingIsSymbol,
  restaurantTotalIsSymbol,
  showDiscountInfo,
  showItemInfo,
  showMaybe,
  showOrderInfo,
  timezoneIsSymbol,
  tipIsSymbol,
  toFillFormTypeDiscountInf,
  toFillFormTypeItemInfo,
  toFillFormTypeOrderInfo,
  totalIsSymbol,
  unitPriceIsSymbol,
  unscrambleDecodeDiscountInfo,
  unscrambleDecodeItemInfo,
  unscrambleDecodeOrderInfo,
  uuidIsSymbol,
  valueIsSymbol
};
